(() => {
  'use strict';
  const selector = '[data-uganda-parent-reviews]';
  let nextId = 0;

  function enhance(root) {
    if (root.parentsReviewsController) return;
    root.parentsReviewsController = true;
    const ids = new WeakMap();
    const expandedReviews = new Set();
    let queued = false;
    let previousWidth = -1;

    function uniqueId(card) {
      if (!ids.has(card)) ids.set(card, `parents-review-${root.dataset.sectionId}-${++nextId}`);
      return ids.get(card);
    }

    function reviewKey(card) {
      return card.closest('[data-index]')?.dataset.index ?? card.querySelector('.testimonial__content')?.textContent;
    }

    function syncHeights() {
      root.style.removeProperty('--parents-card-height');
      root.style.removeProperty('--parents-header-height');
      const cards = Array.from(root.querySelectorAll('.testimonial'));
      const headerHeight = Math.ceil(Math.max(0, ...cards.map(card =>
        card.querySelector('.testimonial__header')?.getBoundingClientRect().height || 0)));
      root.style.setProperty('--parents-header-height', `${headerHeight}px`);
      const cardHeight = Math.ceil(Math.max(0, ...cards.map(card => card.getBoundingClientRect().height)));
      root.style.setProperty('--parents-card-height', `${cardHeight}px`);
    }

    function refresh() {
      queued = false;
      root.dataset.reviewsReady = '';
      root.querySelectorAll('.testimonial').forEach(card => {
        const content = card.querySelector('.testimonial__content');
        if (!content) return;
        content.id = uniqueId(card);
        let row = card.querySelector('.parents-review-action');
        if (!row) {
          row = document.createElement('div');
          row.className = 'parents-review-action';
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'parents-review-toggle swiper-no-swiping';
          button.dataset.parentsReviewToggle = '';
          row.appendChild(button);
          content.insertAdjacentElement('afterend', row);
        }
        const button = row.querySelector('button');
        button.setAttribute('aria-controls', content.id);
        card.dataset.reviewMeasuring = '';
        const fullHeight = content.scrollHeight;
        const lineHeight = parseFloat(getComputedStyle(content).lineHeight);
        delete card.dataset.reviewMeasuring;
        const needsToggle = fullHeight > lineHeight * 3 + 1;
        button.hidden = !needsToggle;
        if (!needsToggle) expandedReviews.delete(reviewKey(card));
        const expanded = expandedReviews.has(reviewKey(card));
        card.dataset.reviewExpanded = String(expanded);
        button.setAttribute('aria-expanded', String(expanded));
        const label = expanded ? 'see less' : 'see more';
        if (button.textContent !== label) button.textContent = label;
      });
      syncHeights();
    }

    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(refresh);
    }

    root.addEventListener('click', event => {
      const button = event.target.closest('[data-parents-review-toggle]');
      if (!button || !root.contains(button)) return;
      const card = button.closest('.testimonial');
      const key = reviewKey(card);
      const expanded = !expandedReviews.has(key);
      if (expanded) expandedReviews.add(key);
      else expandedReviews.delete(key);
      // Swiper may clone a review while looping. Keep every copy in the same state.
      root.querySelectorAll('.testimonial').forEach(copy => {
        if (reviewKey(copy) !== key) return;
        copy.dataset.reviewExpanded = String(expanded);
        const toggle = copy.querySelector('[data-parents-review-toggle]');
        if (toggle) {
          toggle.setAttribute('aria-expanded', String(expanded));
          toggle.textContent = expanded ? 'see less' : 'see more';
        }
      });
      syncHeights();
    });

    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    if ('ResizeObserver' in window) {
      new ResizeObserver(entries => {
        const width = entries[0]?.contentRect.width || 0;
        if (Math.abs(width - previousWidth) > 0.5) {
          previousWidth = width;
          schedule();
        }
      }).observe(root);
    } else {
      window.addEventListener('resize', schedule);
    }
    root.querySelectorAll('img').forEach(image => {
      if (!image.complete) image.addEventListener('load', schedule, { once: true });
    });
    document.fonts?.ready.then(schedule);
    schedule();
  }

  function init() {
    document.querySelectorAll(selector).forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
